export default "__VITE_ASSET__89f10568__"